/*
  NOTE:
   defaultLocale 'en-US' is hard coded;
   CURRENT_USER come from php session and corresponds to the system language unless otherwise specified by the user.
   ```
    $userLanguage = User::getLanguage();
    if (isset($userLanguage['value'])) {
      $userLanguage = $userLanguage['value'];
    }else {
      $systemLanguage = $settingObj->getLanguage();
      $userLanguage = !empty($systemLanguage) ? $systemLanguage : 'en-US';
    }
    $_SESSION['language'] = $userLanguage;
   ```
*/

/**
 * Translates a given string using the locale dictionary.
 * @param {string} msg - String to be translated
 * @param {Object|null} values - Values of placeholders
 * @return {string} - Translated string
 * @note
 * Perform simple values substitution: for complex cases like plural, consider using FormattedMessage.
 * @example
 * console.log(
 *   translate(
 *      'User: {name} - {surname}.',
 *      {
 *         name: 'John',
 *         surname: 'Connor'
 *      }
 *   )
 * );
 */
export const translate = (msg, values = null) => {
    let translated = '';
    if (msg && 'string' === typeof msg) {
        const dictionary = LANG?.[CURRENT_USER?.lang || 'en-US'];
        translated = dictionary?.[msg?.toLowerCase()] || msg;
        if (values) {
            const pattern = ['\\{', '\\}'];
            for (const [key, value] of Object.entries(values)) {
                translated = translated.replace(
                    new RegExp(pattern.join(key), 'gm'),
                    value
                );
            }
        }
    }
    return translated;
};

/**
 * Translates a given string using the formatMessage function from useIntl()
 * @param {function} formatMessage - useIntl() formatMessage function
 * @param {string} msg - String to be translated
 * @param {Object} values - Values of placeholders
 * @return {string} - Translated string
 */
export const useIntlTranslate = (formatMessage, msg, values) => {
    let translated = '';
    if (formatMessage && msg && 'string' === typeof msg) {
        translated = formatMessage(
            {
                defaultMessage: msg,
                id: msg.toLowerCase()
            },
            values || null
        );
    }
    return translated;
};
